
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "configureBrandRedirects",
      resolverType: "mutation",
      routePath: "/configureBrandRedirects",
      httpMethod: "POST",
    });
  